module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLoading) ? _c('div', {
    staticClass: "select-seat"
  }, [_vm._m(0)]) : (!_vm.isLoading) ? _c('div', {
    staticClass: "select-seat"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("選擇 " + _vm._s(_vm.getBookingSelected.area) + " 區 座位")]), _c('div', {
    staticClass: "mb-3"
  }), (_vm.isLogin) ? _c('div', {
    staticClass: "section-wrap info-schedule",
    staticStyle: {
      "margin": "20px auto"
    },
    style: ({
      maxWidth: (_vm.column * 50) + 'px'
    })
  }, [(!_vm.getUser.registered.me) ? _c('div', {
    staticClass: "content border-styled"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("assets/submit-success-icon.png")
    }
  }), _c('span', [_vm._v("尚未購票")]), _c('router-link', {
    staticClass: "btn ghost-btn",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "to": {
        name: 'ticketType'
      }
    }
  }, [_vm._v("立即購票")])], 1) : _vm._e(), (_vm.getUser.registered.me && _vm.getUser.registered.me.status !== 4) ? _c('div', {
    staticClass: "content border-styled"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("assets/submit-success-icon.png")
    }
  }), (_vm.getUser.registered.me) ? _c('span', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.getUser.registered.me.status_string))]) : _vm._e(), _c('hr'), _c('span', [_vm._v("請先購票且完成付款，方可劃位")])]) : _c('div', {
    staticClass: "content border-styled",
    staticStyle: {
      "margin": "20px auto"
    },
    style: ({
      maxWidth: (_vm.column * 50) + 'px'
    })
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("assets/submit-success-icon.png")
    }
  }), _c('span', [_vm._v("點選位置 -> 指派帳號 -> 送出劃位資料")])])]) : _vm._e(), _c('div', {
    staticClass: "mb-10"
  }), (_vm.getSeats.group) ? _c('div', {
    staticClass: "account-wrap"
  }, [_c('ul', {
    staticClass: "selected-group"
  }, [_c('h4', [_vm._v("已選擇座位")]), ((_vm.getSeats.group.chosen && _vm.getSeats.group.chosen.length > 0 === false) && _vm.memberInfo.length === 0) ? _c('li', [_c('span', [_vm._v("尚無人劃位")])]) : _vm._l((_vm.getSeats.group.chosen), function(member) {
    return _c('li', [_c('div', {
      staticClass: "left"
    }, [_c('span', {
      staticClass: "icon"
    })]), _c('div', {
      staticClass: "right"
    }, [_c('div', {
      staticClass: "mySeat"
    }, [_vm._v(_vm._s(member.section) + _vm._s(member.human_seat_x) + _vm._s(member.human_seat_y))]), _c('div', {
      staticClass: "account"
    }, [_vm._v(_vm._s(member.account))])])])
  }), _vm._l((_vm.memberInfo), function(member) {
    return _c('li', [_c('div', {
      staticClass: "left"
    }, [_c('span', {
      staticClass: "icon"
    })]), _c('div', {
      staticClass: "right"
    }, [_c('div', {
      staticClass: "mySeat"
    }, [_vm._v(_vm._s(member.section) + _vm._s(member.human_seat_x) + "-" + _vm._s(member.human_seat_y))]), _c('div', {
      staticClass: "account"
    }, [_vm._v(_vm._s(member.account))])])])
  })], 2), _c('ul', {
    staticClass: "unselected-group"
  }, [_c('h4', [_vm._v("未選擇座位")]), ((_vm.getSeats.group.unChosen && _vm.getSeats.group.unChosen.length > 0 === false)) ? _c('li', [_c('span', [_vm._v("全數劃位完成")])]) : _vm._e(), _vm._l((_vm.getSeats.group.unChosen), function(member) {
    return (_vm.getSeats.group.unChosen && _vm.selectedId(member) < 0) ? _c('li', [_c('span', {
      staticClass: "icon"
    }), _c('span', [_vm._v(_vm._s(member.account))]), _c('span', [_vm._v(_vm._s(member.email))])]) : _vm._e()
  })], 2)]) : _vm._e(), _c('div', {
    staticClass: "account-wrap"
  }, [_c('h4', [_vm._v("選位教學")]), _c('img', {
    attrs: {
      "src": require("assets/steps-help.png")
    }
  })]), _c('div', {
    staticClass: "select-marked",
    style: ({
      maxWidth: (_vm.column * 50) + 'px'
    })
  }, [_c('h4', [_vm._v("區域標誌")]), _c('div', {
    staticClass: "marked silent"
  }, [_c('div', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("潛水區")])]), _c('div', {
    staticClass: "marked integrated"
  }, [_c('div', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("綜合遊戲區")])]), _c('div', {
    staticClass: "marked steam"
  }, [_c('div', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("Steam區")])]), _c('div', {
    staticClass: "marked lol"
  }, [_c('div', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("英雄聯盟區")])]), _c('div', {
    staticClass: "marked fps"
  }, [_c('div', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("射擊遊戲區")])]), _c('div', {
    staticClass: "marked blizzard"
  }, [_c('div', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("暴雪遊戲區")])]), _c('div', {
    staticClass: "marked warfare"
  }, [_c('div', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("戰史遊戲區")])]), _c('div', {
    staticClass: "marked home"
  }, [_c('div', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("無限制區")])])]), _c('h1', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "60px"
    }
  }, [_vm._v(_vm._s(_vm.getBookingSelected.area) + " 區")]), _c('div', {
    staticClass: "stage"
  }, [_c('img', {
    attrs: {
      "src": require("assets/stage.png")
    },
    on: {
      "click": function($event) {
        _vm.isHacked = !_vm.isHacked
      }
    }
  })]), _c('div', {
    staticClass: "select-wrap",
    style: ({
      width: (_vm.column * 50) + 'px'
    })
  }, [_vm._l((_vm.column), function(num) {
    return _c('div', {
      staticClass: "seat-number horizon"
    }, [_c('span', [_vm._v(_vm._s(num))])])
  }), _vm._l((_vm.horizon), function(num) {
    return _c('div', {
      staticClass: "seat-number column",
      style: ({
        top: (num * 38) - 6 + 'px'
      })
    }, [_c('span', [_vm._v(_vm._s(num))])])
  }), _c('div', {
    staticClass: "seats-wrap",
    style: ({
      width: (_vm.column * 50) + 'px'
    })
  }, [_vm._l((_vm.getSeats.seats), function(seat) {
    return (_vm.isMobile === false) ? _c('div', {
      staticClass: "seat",
      class: {
        selected: _vm.isSelected(seat.human_seat), blank: seat.status_string === 'blank', sold: seat.status === true || seat.status === false, notallow: seat.is_scope_allow === false, isMe: seat.is_me === true, isMember: seat.is_group_member, isHacked: _vm.isHacked && seat.status, steam: _vm.getBookingSelected.area === 'A' && _vm.seatsGroup.steam.indexOf(seat.human_seat) > -1, fps: _vm.getBookingSelected.area === 'A' && _vm.seatsGroup.fps.indexOf(seat.human_seat) > -1, integrated: _vm.getBookingSelected.area === 'B' && _vm.seatsGroup.integrated.indexOf(seat.human_seat) > -1, lol: _vm.getBookingSelected.area === 'B' && _vm.seatsGroup.lol.indexOf(seat.human_seat) > -1, blizzard: (_vm.getBookingSelected.area === 'C' && _vm.seatsGroup.blizzardC.indexOf(seat.human_seat) > -1) || (_vm.getBookingSelected.area === 'D' && _vm.seatsGroup.blizzardD.indexOf(seat.human_seat) > -1), silent: _vm.getBookingSelected.area === 'D' && _vm.seatsGroup.silent.indexOf(seat.human_seat) > -1, warfare: _vm.getBookingSelected.area === 'C' && _vm.seatsGroup.warfare.indexOf(seat.human_seat) > -1, home: _vm.getBookingSelected.area === 'C' && _vm.seatsGroup.home.indexOf(seat.human_seat) > -1
      },
      on: {
        "mouseenter": function($event) {
          _vm.showInfo($event, seat)
        },
        "mouseleave": _vm.hideInfo,
        "click": function($event) {
          _vm.selectEvent(seat)
        }
      }
    }) : _vm._e()
  }), _vm._l((_vm.getSeats.seats), function(seat) {
    return (_vm.isMobile === true) ? _c('div', {
      staticClass: "seat",
      class: {
        selected: _vm.isSelected(seat.human_seat), blank: seat.status_string === 'blank', sold: seat.status === true || seat.status === false, notallow: seat.is_scope_allow === false, isMe: seat.is_me === true, isMember: seat.is_group_member, isHacked: _vm.isHacked && seat.status, steam: _vm.getBookingSelected.area === 'A' && _vm.seatsGroup.steam.indexOf(seat.human_seat) > -1, fps: _vm.getBookingSelected.area === 'A' && _vm.seatsGroup.fps.indexOf(seat.human_seat) > -1, integrated: _vm.getBookingSelected.area === 'B' && _vm.seatsGroup.integrated.indexOf(seat.human_seat) > -1, lol: _vm.getBookingSelected.area === 'B' && _vm.seatsGroup.lol.indexOf(seat.human_seat) > -1, blizzard: (_vm.getBookingSelected.area === 'C' && _vm.seatsGroup.blizzardC.indexOf(seat.human_seat) > -1) || (_vm.getBookingSelected.area === 'D' && _vm.seatsGroup.blizzardD.indexOf(seat.human_seat) > -1), silent: _vm.getBookingSelected.area === 'D' && _vm.seatsGroup.silent.indexOf(seat.human_seat) > -1, warfare: _vm.getBookingSelected.area === 'C' && _vm.seatsGroup.warfare.indexOf(seat.human_seat) > -1, home: _vm.getBookingSelected.area === 'C' && _vm.seatsGroup.home.indexOf(seat.human_seat) > -1
      },
      on: {
        "click": function($event) {
          _vm.selectEvent(seat)
        }
      }
    }) : _vm._e()
  }), (_vm.boxSwitch) ? _c('div', {
    staticClass: "hover-box",
    style: ({
      left: _vm.boxPosition.x + 'px',
      top: _vm.boxPosition.y + 'px'
    })
  }, [_c('div', {
    staticClass: "seatId"
  }, [_vm._v(_vm._s(_vm.seatInfo.seatNum))]), _c('div', {
    staticClass: "account"
  }, [_vm._v(_vm._s(_vm.seatInfo.account))])]) : _vm._e()], 2)], 2), _c('hr'), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('div', {
    staticClass: "btn ghost-btn pre-btn",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v("上一步")]), (this.getUser.registered.me && this.getUser.registered.me.status === 4) ? _c('span', [(_vm.getSeats.group && _vm.getSeats.group.unChosen) ? _c('div', {
    staticClass: "btn ghost-btn next-btn",
    attrs: {
      "disabled": this.submitData.register_id.length === 0
    },
    on: {
      "click": _vm.submitButton
    }
  }, [(_vm.submitDisabled) ? _c('div', {
    staticClass: "spinner"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("處理中")]), _c('div', {
    staticClass: "bounce bounce1"
  }), _c('div', {
    staticClass: "bounce bounce2"
  }), _c('div', {
    staticClass: "bounce bounce3"
  })]) : _c('span', [_vm._v("送出")])]) : _vm._e(), (_vm.getSeats.group && _vm.getSeats.group.unChosen) ? _c('div', {
    staticClass: "btn ghost-btn next-btn",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "disabled": this.submitData.register_id.length === 0
    },
    on: {
      "click": _vm.submitClear
    }
  }, [_vm._v("重置已選位置")]) : _vm._e()]) : _vm._e()]), (_vm.isMobile && !_vm.isLoading && _vm.isTip) ? _c('div', {
    staticClass: "scroll-tip",
    on: {
      "click": function($event) {
        _vm.isTip = false
      }
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('img', {
    staticClass: "arrow",
    attrs: {
      "src": require("assets/mobile-scroll-tip-arrow.png")
    }
  }), _c('img', {
    staticClass: "hand",
    attrs: {
      "src": require("assets/mobile-scroll-tip-hand.png")
    }
  }), _c('div', {
    staticClass: "text",
    staticStyle: {
      "text-align": "center",
      "margin-top": "8px"
    }
  }, [_vm._v("座位圖可左右滑動")])])]) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner large center"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("處理中")]), _c('div', {
    staticClass: "bounce bounce1"
  }), _c('div', {
    staticClass: "bounce bounce2"
  }), _c('div', {
    staticClass: "bounce bounce3"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd210960"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/selectSeats.vue
// module id = 584
// module chunks = 1